import { ITranslationItem } from '../../../utils/language';

export const staticWizardData: {
  navigation: {
    next: ITranslationItem;
    previous: ITranslationItem;
  };
} = {
  navigation: {
    next: {
      nl: 'Volgende',
      en: 'Next',
    },
    previous: {
      nl: 'Vorige',
      en: 'Previous',
    },
  },
};
